import { Box, Button, Stack, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import CustomLoader from "../../../../../util/component/CustomLoader";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { execBookingAction } from "../../../api/services";
import useCountdown from "../../../hooks/useCountdown";
import { bookingIdState, expirationDateTimeState, requestUpdateTimeState, stepState } from "../recoil";
import { InsertBookingStep } from "../types";

const DraftTimer = () => {

    const { t } = useTranslation('booking');

    const { dispatchGlobalData } = useContext(GlobalContext);

    const expirationDateTime = useRecoilValue(expirationDateTimeState);
    const setStep = useSetRecoilState(stepState);
    const bookingId = useRecoilValue(bookingIdState);
    const requestUpdateTime = useRecoilValue(requestUpdateTimeState);

    const countdown = useCountdown({
        targetDate: expirationDateTime,
        onExpired: () => {
            setStep(InsertBookingStep.AVAILABILITY_PRICE);
        }
    });

    const execBookingActionMutation = useMutation(
        execBookingAction,
        {
            onError: () => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('message.error.default'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            },
            onSettled: () => {
                setStep(InsertBookingStep.AVAILABILITY_PRICE);
            }
        }
    );

    const onCancel = useCallback(() => {
        if (!bookingId) {
            return;
        }
        countdown.stop();
        execBookingActionMutation.mutate({
            bookingId,
            action: 'CANCEL',
            lastUpdateTime: requestUpdateTime
        })
    }, [bookingId, requestUpdateTime]);

    return (
        <Box
            position="fixed"
            top={56}
            right={16}
            boxShadow="0px 10px 40px rgba(0, 104, 150, 0.2)"
            bgcolor="white"
            borderRadius={2}
            zIndex={100}
            py={1}
            px={2}
        >
            <Stack direction="row" alignItems="center" columnGap={3}>
                <Typography>
                    {`${String(countdown.hours).padStart(2, '0')}:${String(countdown.minutes).padStart(2, '0')}:${String(countdown.seconds).padStart(2, '0')}`}
                </Typography>
                <Button onClick={onCancel}>
                    {t('label.back')}
                </Button>
            </Stack>
            <CustomLoader loading={execBookingActionMutation.isLoading} />
        </Box>
    );
};

export default DraftTimer;